import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';

export function getCotenantApplicationTemplate(applicationId) {
  return apiGet(`${Auth.getApiUrl()}/leads/application_templates/cotenant_application_template`, {
    application_id: applicationId,
  });
}
